export default __webpack_public_path__ + "static/1-fcea051226f62795226fc21c6682ef79.jpeg";